export default {"src":"/_next/static/media/GamStop.8057fd50.svg","height":40,"width":53,"blurWidth":0,"blurHeight":0};